/** Route only explicit local browser custdev requests through the existing proxy. */
export function localCustdevRequestUrl(
  requestUrl: string,
  pageUrl?: string
): string {
  if (!pageUrl) return requestUrl;

  // Check the written authority too: URL normalizes numeric IPv4 aliases.
  const targetAuthority = /^http:\/\/(localhost|127\.0\.0\.1|\[::1\]):8200(?=[/?#]|$)/i;
  const pageAuthority = /^http:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?(?=[/?#]|$)/i;
  if (!targetAuthority.test(requestUrl) || !pageAuthority.test(pageUrl)) {
    return requestUrl;
  }

  try {
    const target = new URL(requestUrl);
    const page = new URL(pageUrl);
    if (
      target.protocol !== "http:" ||
      page.protocol !== "http:" ||
      target.port !== "8200" ||
      target.username || target.password || page.username || page.password
    ) return requestUrl;

    return `/api/proxy/custdev${target.pathname}${target.search}${target.hash}`;
  } catch {
    return requestUrl;
  }
}
